import { DASHBOARD_KEYS } from "../../../../../globalConstants";
import AppWrapper from "../../../../components/cm/AppWrapper";
import CaseListList from "../../../../components/cm/Dashboard/FullPages/CaseList/CaseListList";
import SideBarMain from "../../../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../../../components/cm/SideBarMain/MainNavBarEnum";
import { useSaveCurrentNavigation } from "../../../../hooks/useSaveCurrentNavigation";

const Template = () => {
  useSaveCurrentNavigation({ key: DASHBOARD_KEYS.medicalRecords });

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.DASHBOARD} />}>
      <CaseListList
        customBaseDetailPath={"/medical-records/cases/"}
        customBaseDetailSegment={"/details"}
      />
    </AppWrapper.WithSidebar>
  );
};

export default Template;
